import { canOpenNav, hasAnyRole } from '../navigation/app-navigation';
import { HelpArticle, HelpCapability, HelpContext, Tour } from './help.models';

/** Mismos roles que exige el servidor para crear miembros y gestionar líderes. */
export const MEMBER_WRITE_ROLES = ['Admin', 'Pastor', 'Secretaría'];
/** Mismos roles que exige el servidor para registrar movimientos y guardar el preinforme. */
export const FINANCE_WRITE_ROLES = ['Admin', 'Pastor', 'Tesorería'];

function navCtx(ctx: HelpContext) {
  return { roles: ctx.roles, tutorialsEnabled: ctx.tutorialsEnabled };
}

export function canOpen(ctx: HelpContext, navId: string): boolean {
  return canOpenNav(navId, navCtx(ctx));
}

export function hasCapability(ctx: HelpContext, capability: HelpCapability): boolean {
  switch (capability) {
    case 'createMember':
      return canOpen(ctx, 'members') && hasAnyRole(ctx.roles, MEMBER_WRITE_ROLES);
    case 'manageLeaders':
      return canOpen(ctx, 'users') && hasAnyRole(ctx.roles, MEMBER_WRITE_ROLES);
    case 'writeFinance':
      return canOpen(ctx, 'offerings') && hasAnyRole(ctx.roles, FINANCE_WRITE_ROLES);
    case 'saveReport':
      return canOpen(ctx, 'reports') && hasAnyRole(ctx.roles, FINANCE_WRITE_ROLES);
    case 'switchChurch':
      return ctx.multipleChurches;
    case 'useBankAccounts':
      return canOpen(ctx, 'offerings') && ctx.manejarBancos;
    case 'configureBankAccounts':
      return canOpen(ctx, 'settings') && ctx.bankAccountsFeature;
  }
}

export function canSeeArticle(article: HelpArticle, ctx: HelpContext): boolean {
  if (article.navId && !canOpen(ctx, article.navId)) return false;
  return (article.requires ?? []).every(cap => hasCapability(ctx, cap));
}

export function canStartTour(tour: Tour, ctx: HelpContext): boolean {
  if (!canOpen(ctx, tour.navId)) return false;
  return (tour.requires ?? []).every(cap => hasCapability(ctx, cap));
}
